import { render, staticRenderFns } from "./device-manage.vue?vue&type=template&id=60e963f4&scoped=true"
import script from "./device-manage.vue?vue&type=script&lang=js"
export * from "./device-manage.vue?vue&type=script&lang=js"
import style0 from "./device-manage.vue?vue&type=style&index=0&id=60e963f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e963f4",
  null
  
)

export default component.exports